import React from 'react';
import { FinancialCovenant } from '../../../../redux/types';
import HSTable from '../../../../../../common/HSTable';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../store/rootReducer';
import { Empty, Spin } from 'antd';

const CovenantsTableView: React.FC = () => {
    const loading = useSelector((state: RootState) => state.investments.coLoading);
    const list = useSelector((state: RootState) => state.investments.covenant);

    const columns = [
        {
            title: 'Financial Covenant',
            dataIndex: 'financialCovenant',
            render: (text: string) => <b>{text}</b>,
        },
        {
            title: 'Rules',
            dataIndex: 'rule',
        },
        {
            title: 'Value',
            dataIndex: 'value',
            render: (text: string, row: FinancialCovenant) => (
                <>
                    {text
                        ? `${text} ${row.valueType === 'Percentage' ? '%' : row.valueType === 'Month' ? 'm' : ''}`
                        : ''}
                </>
            ),
            sorter: (a: FinancialCovenant, b: FinancialCovenant) => (a.value || 0) - (b.value || 0),
        },
        {
            title: 'Frequency',
            dataIndex: 'frequency',
        },
        {
            title: 'Assignee',
            dataIndex: 'assignee',
        },
        {
            dataIndex: 'description',
            title: 'Description',
        },
    ];
    return (
        <div>
            {!loading && list.length > 0 && (
                <HSTable columns={columns} data={list} loading={loading} rowKey={(d: FinancialCovenant) => d.uuid} />
            )}
            {!loading && list.length === 0 && (
                <div>
                    <Empty description={`No Financial Covenants Data`} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>
            )}
            {loading && (
                <div className="flex justify-center items-center py-4">
                    <Spin />
                </div>
            )}
        </div>
    );
};

export default CovenantsTableView;
